import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StepStatus } from '~/enums';
import { RootState } from '~/store';

import { pushToGtmOnboardingAction } from '~/store/actions/gtmActions';
import { patchApplication } from '~/store/actions/onboardingActions';
import { useLoanOnboardingApplicationSelectors } from '~/store/selectors/loanOnboardingApplication.selector';
import {
  goToNextStep,
  setHasCompletedBasicSteps,
  updateCurrentStep,
} from '~/store/slices/onboardingApplication.slice';

const useGoToNextStep = () => {
  const dispatch = useDispatch();
  const { stepConfig } = useLoanOnboardingApplicationSelectors();

  // Since stepConfig is zero-indexed, the number representing current step is also index of the next step.

  const { currentStep: nextStepIndex } = useSelector(
    (state: RootState) => state.onboardingApplication
  );

  const onNextStepClick = useCallback(async () => {
    try {
      dispatch(
        pushToGtmOnboardingAction({ actionName: 'next_button_pressed' })
      );
      await dispatch(patchApplication());

      // next step is checkpoint step
      if (stepConfig[nextStepIndex].name === 'checkpoint_step') {
        dispatch(updateCurrentStep(1)); // This happens after we have already removed all previous steps
        dispatch(setHasCompletedBasicSteps(true));
        await dispatch(patchApplication({ currentStepCompleted: false }));
      } else {
        dispatch(goToNextStep());
      }
    } catch (_err: any) {
      dispatch(
        pushToGtmOnboardingAction({
          stepStatus: StepStatus.Error,
          errorMessage: _err.response?.data?.message,
        })
      );
    }
  }, [dispatch, nextStepIndex, stepConfig]);

  return onNextStepClick;
};

export default useGoToNextStep;
